import script from "./SingleTransferPaymentSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleTransferPaymentSuccess.vue?vue&type=script&setup=true&lang=js"

import "./SingleTransferPaymentSuccess.vue?vue&type=style&index=0&id=5c49a2ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c49a2ae"]])

export default __exports__